export const fedFundingConfig = {
  field: 'fund',
  unique: {
    ACAM: { label: 'ACAM', fillColor: [255, 0, 0, 0.65], strokeColor: [0, 0, 0, 0], strokeWidth: 0 },
    'CAF II': { label: 'CAF II', fillColor: [0, 255, 0, 0.65], strokeColor: [0, 0, 0, 0], strokeWidth: 0 },
    'CAF II Auc': { label: 'CAF II Auc', fillColor: [223, 0, 223, 0.65], strokeColor: [0, 0, 0, 0], strokeWidth: 0 },
    RDOF: { label: 'RDOF', fillColor: [0, 0, 255, 0.65], strokeColor: [0, 0, 0, 0], strokeWidth: 0 },
  },
  restricted: true,
};
